<template>
  <v-row density="compact">
    <p>
      Detects a moving-average crossover <strong>event</strong> that happened today versus the prior
      trading day. A "golden cross" fires when the faster MA crosses above the slower MA; a "death
      cross" when it crosses below. Choose a faster and a slower moving average.
    </p>
    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.direction"
        :items="direction"
        item-title="title"
        item-value="value"
        label="Cross Direction"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('direction', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.days_ma1"
        :items="ma_days"
        label="Faster Moving Average Days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('days_ma1', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.days_ma2"
        :items="ma_days"
        label="Slower Moving Average Days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('days_ma2', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      ma_days: [5, 10, 20, 50, 100, 150, 200],
      direction: [
        { title: 'Golden cross (fast crosses above slow)', value: 'golden' },
        { title: 'Death cross (fast crosses below slow)', value: 'death' }
      ],
      defaultTa: {
        enabled: true,
        rule_type: 'ma_cross',
        days_ma1: 50,
        days_ma2: 200,
        direction: 'golden',
        long_short: 'long'
      }
    }
  },

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'ma_cross') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
